import * as React from "react";
import {sendRequest} from "../../helpers/ajax";
import IEmailPasswordResetRequest from "../../types/IEmailPasswordResetRequest";
import IEmailPasswordResetResponse from "../../types/IEmailPasswordResetResponse";
import IResponse from "../../types/IResponse";
import ForgotPassword from "./ForgotPassword";

class ForgotPasswordContainer extends React.Component{

    constructor(props: any) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    public render() {
        return (
            <ForgotPassword 
                onSubmit={this.onSubmit} 
            />
        );
    }

    private async onSubmit(email: string): Promise<boolean> {
        const request: IEmailPasswordResetRequest = { email };
        const response = await sendRequest<IResponse<IEmailPasswordResetResponse>>("/api/Authentication/EmailPasswordReset", "POST", request);

        if (response && response.success && response.payload.success) {
            return true;
        } else {
            return false;
        }
    }
}

export default ForgotPasswordContainer;



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPasswordContainer.tsx